(() => {
    const switcherLabelsContainers = document.querySelectorAll('.menu-drawer__navItem__submenu__switcher');

    switcherLabelsContainers.forEach((switcherLabelsContainer) => {
        const switcherLabels = switcherLabelsContainer.querySelectorAll('.menu-drawer__navItem__submenu__switcher-label');

        switcherLabels.forEach((switcherLabel) => {
            switcherLabel.addEventListener('click', (e) => {
                switcherLabels.forEach((label) => {
                    label.removeAttribute('active');
                });
                e.currentTarget.setAttribute('active', '');
            });
        });
    });
})();